import { isAppWebView } from '@/shared/lib/appBridge/appBridge.utils'

const UNAUTHORIZED = 401

/**
 * 실패한 요청에서 뽑아낸 값.
 *
 * 원본 AxiosError가 아니라 이 값만 받는다. 인터셉터가 민감 정보(요청 바디·토큰)를
 * 지운 뒤에도 판정이 가능해야 하므로, 판정에 필요한 값을 미리 확보해 넘긴다.
 */
export interface IRequestErrorInfo {
  method: string
  url: string
  status?: number
  /** 백엔드 ErrorCode. BFF가 전달한 경우에만 채워진다. */
  code?: string
}

export interface IHandledErrorRule {
  /** 이 상태코드일 때만 스킵 후보가 된다. */
  statuses: number[]
  /**
   * 백엔드 ErrorCode. 지정하면 code까지 일치해야 스킵한다.
   * BFF가 code를 내려주는 API에만 쓴다.
   */
  codes?: string[]
}

let handledErrors: Record<string, IHandledErrorRule> = {}

/**
 * "UI가 이미 처리하는 정상적인 실패"를 등록한다.
 * shared가 특정 도메인을 알지 않도록, 규칙은 해당 도메인이 넣는다.
 */
export const registerHandledErrors = (
  rules: Record<string, IHandledErrorRule>
): void => {
  handledErrors = { ...handledErrors, ...rules }
}

const findRule = (url: string): IHandledErrorRule | undefined =>
  Object.entries(handledErrors).find(([path]) => url.includes(path))?.[1]

/**
 * 등록된 규칙에 걸려 RUM 보고를 건너뛸지 판단한다.
 * 판단이 서면 건너뛰고, 애매하면 보고한다(= 놓치는 것보다 시끄러운 편을 택한다).
 */
export const shouldSkipErrorReport = ({
  url,
  status,
  code,
}: IRequestErrorInfo): boolean => {
  if (!status) return false // 네트워크 오류 · 타임아웃
  // TODO: 토큰 갱신로직 적용 후 제거 예정
  if (status === UNAUTHORIZED && isAppWebView()) return true

  const rule = findRule(url)
  if (!rule) return false
  if (!rule.statuses.includes(status)) return false
  if (!rule.codes) return true
  if (!code) return false

  return rule.codes.includes(code)
}
